<div class="status-card">
  <div class="status-content">
    <div class="status-info">
      <div class="status-color" [style.backgroundColor]="status.color"></div>
      <div class="status-title">{{ status.name }}</div>
      <div class="status-badge" *ngIf="status.isDefault">{{ 'request_v2.status_card.default' | translate }}</div>
    </div>
    
    <div class="status-actions">
      <button mat-icon-button [matMenuTriggerFor]="menu" class="more-button">
        <i class="icon-more-vertical"></i>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="onEdit()">
          <span>{{ 'request_v2.common.edit' | translate }}</span>
        </button>
        <button mat-menu-item (click)="onDelete()">
          <span>{{ 'request_v2.common.delete' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
  
  <div class="status-type-container" *ngIf="statusType">
    <div class="section-label">{{ 'request_v2.status_card.status_type' | translate }}</div>
    <div class="status-type-value">{{ statusType }}</div>
  </div>
</div> 